<h1
  mat-dialog-title
  sharedUiModalClose
  i18n="@@addSiteModalHeader"
  data-testid="add-site-modal-title"
  (closed)="close()"
  >Add site</h1
>

<ng-scrollbar autoHeightDisabled="false">
  <mat-dialog-content>
    <shared-ui-info
      class="mb-[16px] block"
      [text]="warningText"
      [type]="InfoTypeEnum.WARNING"
    ></shared-ui-info>

    <shared-form-input-text
      class="mb-[16px] block"
      i18n-title="@@addSiteModalNameTitle"
      title="Site name (optional)"
      [tabIndex]="1"
      [control]="form.controls.name"
      [validationErrors]="validationConfig.name.errors"
    ></shared-form-input-text>

    <shared-form-adding-by-group
      class="mb-[16px] flex items-center justify-between"
      [radioButtonData]="addingByGroupData"
      (addingByChange)="setAddingBy($event)"
    ></shared-form-adding-by-group>

    <div class="mb-[16px]">
      @if (addingBy === 'keendns') {
        <shared-form-input-text
          [title]="addressTitle"
          testId="add-site-modal-keendns-input"
          [tabIndex]="2"
          [withValidationDelay]="true"
          [control]="form.controls.keenDns"
          [validationErrors]="validationConfig.keenDnsControl.errors"
        ></shared-form-input-text>
      } @else {
        <shared-form-input-text
          i18n-title="@@addSiteModalServiceTagTitle"
          title="Service tag *"
          testId="add-site-modal-service-tag-input"
          [mask]="'000-000-000-000-000'"
          [withValidationDelay]="true"
          [tabIndex]="2"
          [control]="form.controls.serviceTag"
          [validationErrors]="validationConfig.serviceTagControl.errors"
        ></shared-form-input-text>
      }
    </div>

    <div class="mb-[16px]">
      <shared-ui-info [text]="infoText"></shared-ui-info>
    </div>

    <div class="mb-[16px]">
      <shared-form-input-text
        i18n-title="@@addSiteModalLoginTitle"
        title="Login *"
        testId="add-site-modal-login-input"
        [tabIndex]="3"
        [control]="form.controls.login"
        [validationErrors]="validationConfig.login.errors"
      ></shared-form-input-text>
    </div>

    <div class="mb-[16px]">
      <shared-form-input-text
        i18n-title="@@addSiteModalPasswordTitle"
        title="Password *"
        testId="add-site-modal-password-input"
        type="password"
        [tabIndex]="4"
        [control]="form.controls.password"
        [validationErrors]="validationConfig.password.errors"
      ></shared-form-input-text>
    </div>

    @if (form.controls.isPrivate && validationConfig.isPrivate) {
      <div class="mb-[16px] flex items-center">
        <shared-form-input-checkbox
          class="add-node-form__checkbox-input"
          testId="add-site-modal-is-private-checkbox"
          [control]="form.controls.isPrivate"
          [validationErrors]="validationConfig.isPrivate.errors"
          i18n-title="@@addSiteModalMarkAsPrivateTitle"
          title="Mark as private"
          [tabIndex]="5"
        ></shared-form-input-checkbox>

        <svg
          class="add-node-form__lock-icon fill-base-500 ml-[15px] h-[16px] w-[12px] cursor-pointer"
          i18n-matTooltip="@@addSiteModalMarkAsPrivateTooltip"
          matTooltip="Private. Team can’t view this site"
        >
          <use xlink:href="#lock"></use>
        </svg>
      </div>
    }

    <shared-ui-info [text]="siteAgreementText"></shared-ui-info>
  </mat-dialog-content>
</ng-scrollbar>

<mat-dialog-actions>
  <shared-ui-button
    class="flex-1"
    mat-dialog-close
    size="stretch"
    mode="outline"
    [tabindex]="6"
    [disabled]="isSubmitting()"
    i18n="@@addSiteCancelButton"
    >Cancel</shared-ui-button
  >

  <shared-ui-button
    class="flex-1"
    size="stretch"
    testId="add-site-modal-add-site-button"
    [tabindex]="7"
    [disabled]="isSubmitting() || form.invalid"
    (clicked)="addSite()"
    i18n="@@addSiteAddButton"
    >Add site</shared-ui-button
  >
</mat-dialog-actions>
